import TextField from '@mui/material/TextField';

export default function InputField ({ label, value, onHandleInputChange }) {

    return(
        <div>
            {/* <label>{label}</label> */}
            <TextField value={value} onChange={(e)=> onHandleInputChange(e.target.value)} id="outlined-basic" label={label} variant="outlined" />
        </div>
    )
};